'use strict';

/**
 * 
 * Class for holding "questionnaire-answer-disagree-nae" value set 
 * options for answering question. 
 * 
 * @see: http://www.documental.ee/questionnaire-answer-disagree-nae
 * 
 * @note: 
 *   Basically it should implement FHIR ValueSet chema, but currently not needed. 
 *   https://www.hl7.org/fhir/valueset.html
 * 
 * with following options: 
 * - A   => Agree
 * - D   => Disagree
 * - NAE => Not able to evaluate
 * 
 */


function DisagreeNae() {
  
  this.id    = "questionnaire-answer-disagree-nae";
  this.url   = "http://www.documental.ee/questionnaire-answer-disagree-nae";
  this.name  = "Disagree and Not able to evaluate answer options for question";
  
  this.optionValues = [
    {
      code: "D",
      display: "Disagree"
    },
    {
      code: "NAE",
      display: "Not able to evaluate"
    }
  ];
  
  return this;
}


/**
 * -
 * 
 * @return Array
 */
DisagreeNae.prototype.getOptions = function( ) {
  return this.optionValues;
};


/**
 * -
 * 
 * @return Array
 */
DisagreeNae.prototype.getKeyValuePairs = function( ) {
  var vals = [];
  
  for( var i in this.optionValues ){
    vals[ this.optionValues[ i ].code ] = this.optionValues[ i ].display;
  }

  return vals;
};


export default DisagreeNae;